import React, { useContext, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import Select from "react-select";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import classNames from "classnames";
import { getData } from "../../../utils/api";
import { ItemType, Select2Data, SelectImageData } from "../../../utils/common";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, IMG_URL, getDimension } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    control,
    setValue,
    getValues,
    watch,
  } = useForm();

  const imageFile = watch("image"); // Track image input

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("item_type_id", data?.item_type_id?.value);

      // Use the image from gallery selection or file upload
      if (data?.image && data?.image[0]) {
        sendData.append("image", data?.image[0]);
      }

      const response = await postData(`/admin/masters/category`, sendData);

      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
      } else {
        setShowModal({
          code: response?.code,
          message: response?.errors,
        });
      }

      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  useEffect(() => {
    if (imageFile && imageFile[0]) {
      setImagePreview(URL.createObjectURL(imageFile[0]));
      return () => URL.revokeObjectURL(imageFile[0]); // cleanup
    } else {
      setImagePreview(null);
    }
  }, [imageFile]);

  const [itemType, setItemType] = useState([]);
  const GetAllItemType = async () => {
    const response = await getData("/common/masters/all-item-type");

    if (response?.success) {
      setItemType(await Select2Data(response?.data, "item_type_id"));
    }
  };

  useEffect(() => {
    GetAllItemType();
  }, []);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Category
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Item Type</Form.Label>
                    <Controller
                      name="item_type_id" // name of the field
                      {...register("item_type_id", {
                        required: "Select Category",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.item_type_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={itemType}
                        />
                      )}
                    />
                    {errors.item_type_id && (
                      <span className="text-danger">
                        {errors.item_type_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label> Design Category</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Category"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Image</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="file"
                        name="image"
                        placeholder="Image"
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        {...register("image", {
                          required: "Image is required",
                          // validate: async (value) => {

                          //   if (typeof value !== "string") {
                          //     const fileTypes = ["jpg", "png", "jpeg", "webp"];
                          //     const fileType = value[0].name?.split(".")[1];

                          //     if (!fileTypes.includes(fileType)) {
                          //       return `please upload a valid file format. (${fileTypes})`;
                          //     }
                          //     const sizes = await getDimension(value[0]);
                          //     if (sizes.width !== 928 && sizes.height !== 945) {
                          //       return "Image width and height must be 928 px and 945 px";
                          //     }
                          //     const fileSize = Math.round(value[0].size / 1024);
                          //     if (fileSize > 500) {
                          //       return "file size must be lower than 500kb";
                          //     }

                          //     // if (!fileTypes.includes(fileType)) {
                          //     //   return `please upload a valid file format. (${fileTypes})`;
                          //     // }

                          //     // const sizes = await getDimension(value[0]);
                          //     // if (
                          //     //   sizes.width !== 200 &&
                          //     //   sizes.height !== 200
                          //     // ) {
                          //     //   return "Image width and height must be 200 px and 200 px";
                          //     // }

                          //     // const fileSize = Math.round(
                          //     //   value[0].size / 1024
                          //     // );
                          //     // if (fileSize > 500) {
                          //     //   return "file size must be lower than 500kb";
                          //     // }
                          //   }
                          // },
                        })}
                        accept="image/*"
                        // onChange={handleImageChange}
                      />
                    </InputGroup>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  {imagePreview && (
                    <div className="image-preview-container">
                      <img
                        src={imagePreview} // Display the selected image preview
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  )}
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
